import { createComponentClickedEvent, track } from "@/analytics/events/base"
import { persistentAtom } from "@nanostores/persistent"
import type { TrustedPartnerFragment } from "@/generated/graphql"

export const $trustedPartnersWidget = persistentAtom<"true" | "false">(
  "trustedPartnersWidget",
  "true"
)

export const trackTrustedPartnerClicked = (
  componentId: string,
  componentFunction: string,
  partner?: TrustedPartnerFragment
) => {
  track(
    createComponentClickedEvent({
      current_screen: "Loan Dashboard",
      component_id: componentId,
      component_type: "text_link",
      component_function: componentFunction,
      object_name: partner?.slug,
    })
  )
}
